import React from 'react';
//import {useState} from 'react';
// import {useContext} from 'react';
// import { Link } from 'react-router-dom';
//import Bd from "../../bd"

import Redirecinar from '../../components/Redirecinar';
// import Header from '../../components/Header';
// import Footer from '../../components/Footer'
// import BtnVoltar from '../../components/BtnVoltar'

// import useFind from '../../hooks/useFind'
// import {useFetch} from '../../hooks/useFetch'
// import {UserContext} from '../../hooks/UserContext'

function Sobre(){

	return (
	  <>
	    {/* menu superior do dj*/}
	    {/* <BtnVoltar/> */}
	    {/*
	    */}
	    {/*Conteudo*/}
	    {/* <Body/> */}
	    {/* <BodyCanva/> */}
		<Redirecinar to="https://www.canva.com/design/DAEy3MBaXQU/4mn3CvmHv8MSuNySdbRd5Q/view?website#2"/>
	    {/*Rodape da sophia*/}
	    {/* <Footer /> */}
		{/* <p>Ícones feitos pelo Freepik de www.flaticon.com</p> */}
	  </>
	);
};

export default Sobre;
// const cssBody = {
// 		"position":			"relative",
// 		 "width":			"100vw",
// 		 "height":			"100vh",
// 	 "padding-top":			"56 2500%",
//
// "padding-bottom":			"48px",
// 	 "box-shadow":			"0 2px 8px 0 rgba(63,69,81,0,16)",
// 	 "marginBop":			"1 6em",
// 	 "marginBottom":			"0 9em",
// 	 "overflow":				"hidden",
// 	"border-radius":			"8px",
// 		"will-change":			"transform",
// }
// function BodyCanva(){
// 	console.log(cssBody);
// 	console.log(Body);
// 	//style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0;margin: 0;"
// 	return (
// 		<div  style={cssBody}>
// 		  <iframe style={cssBody} title = "Sobre" sloading="lazy"
// 		    src="https://www.canva.com/design/DAEy3MBaXQU/4mn3CvmHv8MSuNySdbRd5Q/view?embed&website#2" allowfullscreen="allowfullscreen" allow="fullscreen">
// 		  </iframe>
//
// 		</div>
// 	);
// }
//
// function Body() {
//
//     return (<div style={{
//             "position" : "relative",
//             "width" : "100%",
//             "height" : "100%",
//             "paddingTop": "56.2500%",
//             "paddingBottom" : "48px",
//             // "box-shadow" : "0 2 px 8 px 0 rgba(63, 69, 81, 0.16)",
//             "marginTop" : "1.6em",
//             "marginBottom" : "0.9em",
//             "overflow" : "hidden",
//             "borderRadius" : "8px",
//             "willChange" : "transform"
//         }}>
//         <iframe title = "Sobre"  style={{
//                 "position" : "absolute",
//                 "width" : "100%",
//                 "height" : "100%",
//                 "top" : "0",
//                 "left" : "0",
//                 "border" : "none",
//                 "padding" : "0",
//                 "margin" : "0",
//                 "scrollbarWidth": "none",
//                 "overflowY": "hidden"
//             }} src="/img/about/index.html"></iframe>
//     </div>);
// }

/*
<div style="position: relative; width: 100%; height: 0; padding-top: 56.2500%;
 padding-bottom: 48px; box-shadow: 0 2px 8px 0 rgba(63,69,81,0.16); margin-top: 1.6em; margin-bottom: 0.9em; overflow: hidden;
 border-radius: 8px; will-change: transform;">
  <iframe loading="lazy" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0;margin: 0;"
    src="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAEy3MBaXQU&#x2F;watch?embed" allowfullscreen="allowfullscreen" allow="fullscreen">
  </iframe>
</div>
<a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAEy3MBaXQU&#x2F;watch?utm_content=DAEy3MBaXQU&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">Sobre o Inova e MM 2021,2</a> de IDE Inovadores de Elite

*/
